/**
 *
 * @name app.module.common.utils.ModalAccessibility
 * @date 5/28/2015.
 * @copyright 2015 Empower Retirement
 *
 */

/** When opening a modal use this service by:
* 1: reuquire this util: var ModalAccessibility = require('path-to/util/ModalAccessibility');
* 2: Target your modal's parent selector: ModalAccessibility.onOpenModal('.modal-dialog');
* 3: Test your tabbing, and the ability to close the modal with escape key
* 4: Elements that aren't represented within the "focusableElementsString" must have tabindex="0" added to them.
* 5: Unfocusable elements require the tabindex='-1' attribute
* 6: trapEscapeKey works by finding and triggering click event on .btn-cancel

*/

import isVisibile from "../util/isVisible";
var ModalAccessibility = {
    // a list of focusable elements
    focusableElementsString:
        "a[type='button'], a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]",

    /**
     * onOpenModal
     */
    onOpenModal: function (modalSelector) {
        // set timeout needed to wait for modal to be inserted into the DOM
        setTimeout(function () {
            var modal = document.querySelector(modalSelector);
            // set accessibilty attributes on modal
            modal?.setAttribute("role", "dialog");
            modal?.setAttribute("tabindex", "0");
            modal?.setAttribute("aria-hidden", "false");

            // focus on the modal
            modal?.focus();

            modal?.addEventListener("keydown", function (event) {
                ModalAccessibility.trapTabKey(angular.element(this), event);
            });
            modal?.addEventListener("keydown", function (event) {
                ModalAccessibility.trapEscapeKey(angular.element(this), event);
            });
        }, 800);
    },

    /**
     * trapTabKey
     * Prevents the user from tabbing away from the active modal
     */
    trapTabKey: function (obj, evt) {
        // if tab or shift-tab pressed
        if (evt.which === 9) {
            // get list of all children elements in given object
            var o = Array.from(obj.querySelectorAll("*"));

            // get list of focusable items
            var focusableItems;
            focusableItems = o.filter((e) => isVisibile(e));

            // get currently focused item
            var focusedItem;
            focusedItem = document.activeElement;

            // get the number of focusable items
            var numberOfFocusableItems;
            numberOfFocusableItems = focusableItems.length;

            // get the index of the currently focused item
            var focusedItemIndex;
            focusedItemIndex = focusableItems.indexOf(focusedItem);

            if (evt.shiftKey) {
                //back tab
                // if focused on first item and user preses back-tab, go to the last focusable item
                if (focusedItemIndex === 0) {
                    focusableItems[numberOfFocusableItems - 1].focus();
                    evt.preventDefault();
                }
            } else {
                //forward tab
                // if focused on the last item and user preses tab, go to the first focusable item
                if (focusedItemIndex === numberOfFocusableItems - 1) {
                    focusableItems[0].focus();
                    evt.preventDefault();
                }
            }
        }
    },

    /**
     * trapEscapeKey
     * Closes the modal when the user keysdown the esc key
     */
    trapEscapeKey: function (obj, evt) {
        // if escape pressed
        if (evt.which === 27) {
            var cancelElement;
            cancelElement = obj[0].querySelector(".btn-cancel");

            // close the modal window
            cancelElement?.click();

            // remove events from modal
            obj.off();

            evt.preventDefault();
        }
    }
};

export default ModalAccessibility;
